<template>
  <v-col class="pa-0">
    <v-row class="ma-0 pa-0">
      <v-col align="center" cols="8" offset="2">
        <h2>{{ $translate('RESET_PASS_MAIL_SENT_TITLE') }}</h2>
      </v-col>
      <v-col align="end" cols="2">
        <v-icon
          size="20"
          @click="$emit('triggerPopup', { toggle: false, component: 'Login' })"
        >
          ti-close
        </v-icon>
      </v-col>
    </v-row>
    <v-col align="center" justify="center" class="py-5">
      <v-icon size="140" color="#a7dc86"> mail_outline </v-icon>
    </v-col>
    <v-col class="pa-3">
      <v-alert color="blue" text type="info">
        {{ $translate('CHECK_SPAM_REMINDER') }}
      </v-alert>
    </v-col>
    <v-card flat color="#d9d9d9" class="mt-3">
      <v-row class="mx-3 my-0 pa-4" align="center" justify="center" dense>
        <v-col align="center">
          <p class="mb-0">{{ $translate('BACK_TO') }}</p>
        </v-col>
        <v-col align="center" justify="center">
          <v-btn
            color="primary"
            class="primary-font-color"
            depressed
            large
            @click="$emit('triggerPopup', { toggle: true, component: 'Login' })"
          >
            {{ $translate('LOGIN') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
import uiHelpers from '../../shared/ui_helpers';

export default {
  name: 'AccountResetPasswordSuccess',
  mixins: [uiHelpers],
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style scoped>
.titleThanks {
  font-size: 2rem !important;
  color: #101010;
  font-weight: 400;
}
</style>
